import { whiteColor, hexToRgb, warningColor } from 'assets/jss/material-dashboard-pro-react';

const bulkNumberListStyle = () => ({
	footerContainer: {
		backgroundColor: whiteColor,
		paddingLeft: '16px',
		paddingRight: '16px',
		borderTopLeftRadius: '8px',
		borderTopRightRadius: '8px',
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
	},
	loadingWrapper: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		background: `rgba(${hexToRgb(whiteColor)}, 0.9)`,
		zIndex: 1000,
	},
	prediscount: {
		'& p': {
			textDecoration: 'line-through',
			color: warningColor[0],
		},
	},
	deviceName: {
		'& p': {
			textOverflow: 'ellipsis',
			width: '180px',
		},
	},
});

export default bulkNumberListStyle;
